// ChiSiamoPage.js
import React from 'react';
import {Link} from "react-router-dom";
import './ChiSiamo.css';

const ChiSiamoPage = () => {
    return (

        <div className="chisiamo-container">
            <img src="chi-siamo-bkg.jpg" width='100%'/>
            <div className="description-container">
                <div className="description">
                    <p>Ri.Ma., fondata nel 2022 e con sede in Lombardia, è un'azienda dinamica e innovativa che nasce dalla profonda passione per la tecnologia e dall'esperienza consolidata nel settore IT, maturata sia in Italia che all'estero.
                        <br/>La nostra missione è fornire soluzioni personalizzate, rivolte sia a piccole e medie imprese che a clienti privati, con l'obiettivo di soddisfare le specifiche esigenze di ogni cliente.
                        <br/><br/>Ci distinguiamo per l'attenzione ai dettagli e la costante ricerca di soluzioni tecnologiche avanzate, che ci consente di offrire prodotti e servizi sempre all'avanguardia, intuitivi e facilmente aggiornabili.
                        <br/>Garantiamo trasparenza e professionalità in ogni fase del nostro lavoro, assicurando un alto livello di qualità e affidabilità.
                        <br/><br/>
                        Per ulteriori informazioni sui servizi disponibili, vi invitiamo a visitare la sezione <b><Link to="/servizi">Servizi</Link></b>.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ChiSiamoPage;